import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';


import Iconify from 'src/components/iconify';
import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

const ROWS = [
  'Individuelle Beratung und Begleitung',
  'Agiles Projektmanagement',
  'Engagierte Teamarbeit',
  'Flexibilität',
  'Rundum-Service',
  'Transparentes Monitoring',

];

// ----------------------------------------------------------------------

export default function MarketingLandingAbout() {
  return (
    <Container
      sx={{
        py: { xs: 5, md: 10 },
      }}
    >
{/*       <Image
        alt="landing about"
        src="/assets/images/marketing/marketing_post_hero.jpg"
        ratio="16/9"
        sx={{
          borderRadius: 1.5,
          mb: { xs: 5, md: 10 },
        }}
      /> */}

      <Grid
        container
        columnSpacing={{ xs: 0, md: 3 }}
        style={{ '--Grid-columnSpacing': 'initial' }} // Override here
        rowSpacing={{ xs: 5, md: 0 }}
        justifyContent="space-around"
      >
        <Grid
          xs={12}
          md={6}
          sx={{
            textAlign: { xs: 'center', md: 'right' },
          }}
        >
          <Typography component="div" variant="overline" sx={{ color: 'text.disabled' }}>
            Über Uns
          </Typography>

          <Typography variant="h2" sx={{ my: 3 }}>
            Expertise
          </Typography>

          <Typography sx={{ color: 'text.secondary' }}>
            Mit über 10 Jahren umfangreicher Erfahrung im Projektmanagement begleiten wir dich von der Konzeption bis zur Fertigstellung.
          </Typography>

          <Button
            size="large"
            component={Link} 
            color="inherit"
            endIcon={<Iconify icon="carbon:chevron-right" />}
            sx={{ my: 5 }}           
            to="/agentur/ueber-mich"
          >
            Mehr
          </Button>
        </Grid>
<Grid container justifyContent="left" >

        <Grid xs={12} md={6}  pt={{ xs: 1, md: 6 }} container  alignItems="left">
          <Stack spacing={5}>
  
              <Stack
                key='Vorteile'
                direction="row"
                alignItems="left"
                divider={
                  <Divider
                    flexItem
                    orientation="vertical"
                    sx={{ ml: { xs: 2, sm: 3 }, mr: { xs: 2, sm: 3 }, borderStyle: 'dashed' }}   
                  />
                }
              >
                <Stack spacing={1} sx={{ width: 1, maxWidth: 100 }}>
                  <Stack direction="row">
                    <Typography variant="h2">8</Typography>
                    <Box component="span" sx={{ color: 'primary.main', typography: 'h4' }}>
                      +
                    </Box>
                  </Stack>

                  <Typography variant="overline" sx={{ color: 'text.disabled' }}>
                  Jahre Erfahrung im Projekt-<br />management
                  </Typography>
                </Stack>
              
                <Stack spacing={1}>
                  {ROWS.map((line) => (
                    <Stack key={line} direction="row" alignItems="center">
                      <Box
                        sx={{
                          mr: 1.5,
                          width: 20,
                          height: 20,
                          display: 'flex',
                          borderRadius: '50%',
                          alignItems: 'center',
                          justifyContent: 'center',
                          bgcolor: (theme) => alpha(theme?.palette?.secondary?.main, 0.08),
                        }}
                      >
                        <Iconify
                          icon="carbon:checkmark"
                          sx={{ width: { xs: 12, sm: 16 }, height: { xs: 12, sm: 16 }, color: 'secondary.main' }}
                        />
                      </Box>
                      <Typography variant="body2" > {line} </Typography>
                      
                    </Stack>
                  ))}
                </Stack>


              </Stack>
          </Stack>
        </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}
